import React from 'react';
import { Eye } from 'lucide-react';

export default function PartnerReports() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Reports & P&L</h1>
          <p className="text-slate-500 text-sm">View reports and profit & loss statements</p>
        </div>
        <div className="text-xs text-slate-400 bg-amber-50 px-3 py-1 rounded-full border border-amber-200">🔒 Read-only</div>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <div className="text-4xl mb-4">📊</div>
        <h3 className="text-lg font-semibold text-slate-700">Reports Coming Soon</h3>
        <p className="text-slate-500 text-sm">Financial reports and P&L statements will be available here.</p>
        <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-3 inline-block">
          <p className="text-xs text-amber-700 flex items-center gap-2">
            <Eye className="w-4 h-4" /> Read-only access
          </p>
        </div>
      </div>
    </div>
  );
}
